import styled from 'styled-components';
import selectedFiltersIcon from 'images/selectedFiltersIcon.svg';

export const AnimationContainer = styled.div.attrs(
  props => ({
    style: {
      opacity: props.opacity,
      width: props.width,
      ...props.style,
    },
  })
)`
  display: inline-block;
  overflow: hidden;
`;

export const SelectedFilterContainer = styled.div`
  font-weight: 500;
  font-size: 9px;
  line-height: 13px;
  border-radius: 5px;
  padding: ${({ theme }) => `${theme.padding.small} ${theme.padding.medium}`};
  margin-bottom: 20px;
  line-height: 40px;
  background: url('${selectedFiltersIcon}') 25px center no-repeat;
  background-color: white;
  position: relative;
  width: 100%;
`;

export const TagContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
  line-height: 0;
  padding: 0 80px 0 30px;
`;

export const ClearFilterButton = styled.div`
  position: absolute;
  white-space: nowrap;
  right: 20px;
  top: 10px;
  font-size: 12px;
  color: #CBCED6;

  &:hover {
    cursor: pointer;
  }
`;
